<template>
  <div class="container">
    <div class="content-list">
      <el-table
          :data="resultList"
          border
          style="width: 100%">
        <el-table-column
            align="center"
            label="反馈详情"
            prop="description">
        </el-table-column>
        <el-table-column
            align="center"
            label="反馈图片"
            prop="images"
            width="850">
          <!-- images -->
          <template #default="scope">
            <el-image
                v-for="(item, index) in scope.row.images"
                :key="index"
                :src="item"
                style="width: 100px; height: 100px; margin-right: 10px"
                fit="cover">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column
            align="center"
            label="处理状态"
            prop="status"
            width="180">
          <!-- 0-待处理；1-已处理 -->
          <template #default="scope">
            <!-- Type string is not assignable to type TagType  -->
            <el-tag v-if="scope.row.status === '0'" type="danger"> 待处理 </el-tag>
            <el-tag v-else-if="scope.row.status === '1'" type="success"> 待处理 </el-tag>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            label="反馈用户"
            prop="username"
            width="380">
        </el-table-column>
      </el-table>
    </div>
    <div class="page-part">
      <el-pagination
          size="small"
          background
          @current-change="loadByPage"
          :page-size="pagination.pageSize"
          :current-page="pagination.currentPage"
          layout="prev, pager, next"
          :total="pagination.total">
      </el-pagination>
    </div>
  </div>
</template>

<script lang="ts">
import * as api from '@/api/api'

export default {
  name: 'Feedback1',
  data() {
    return {
      name: 'Feedback1',
      pagination: {
        pageSize: 1,
        total: 0,
        currentPage: 1,
        totalPage: 1
      },
      resultList: [],
    }
  },
  methods: {
    loadByPage(page) {
      this.pagination.currentPage = page;
      this.listContent();
    },
    listContent() {
      api.listFeedback(this.pagination.currentPage, this.pagination.pageSize).then(result => {
        if (result.code === api.SUCCESS_CODE) {
          let data = result.data;
          this.resultList = data.list;
          this.pagination.currentPage = data.currentPage;
          this.pagination.pageSize = data.pageSize;
          this.pagination.total = data.total;
          this.pagination.totalPage = data.totalPage;
        }
      })
    }
  },
  mounted() {
    // 处理mp3上传地址，拼接上token信息
    const token = this.$store.state.user.token;
    this.uploadFilePath = api.baseUrl + `/md/file/app?ct-sob-admin-token=${token}`
    console.log(1255555555555555555)
    this.listContent();
  },
}
</script>

<script lang="ts" setup></script>

<style lang="scss" scoped></style>
